<template>
  <v-layout column align-center>
    <v-flex xs12>
      <v-card flat class="Title" color="transparent">
        <v-flex layout column align-center justify-center>
          <img src="/images/logo_text.png" alt="logo explorama" />
          <p>{{ $t('accountCreation.title') }}</p>
          <!--p class="grey--text">{{ $t('accountCreation.subtitle') }}</p-->
        </v-flex>
      </v-card>
      <v-card class="primaryCard">
        <v-layout row wrap>
          <v-flex xs4>
            <v-img
              class="primaryCard-img"
              src="https://images.unsplash.com/photo-1420593248178-d88870618ca0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80"
              alt="image left card"
            />
          </v-flex>
          <v-flex xs8>
            <v-stepper v-model="stepper">
              <v-stepper-header>
                <v-stepper-step :complete="stepper > 1" step="1">
                </v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="stepper > 2" step="2">
                </v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="stepper > 3" step="3">
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-form ref="firstForm" v-model="validFirstForm">
                    <v-container grid-list-md text-xs-center>
                      <v-layout column>
                        <v-flex xs12>
                          <v-select
                            v-model="account.type"
                            :rules="rules.account.typeRules"
                            :label="$t('accountCreation.accountType')"
                            :items="accountTypeOptions"
                            required
                          >
                          </v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="account.name"
                            :rules="rules.account.nameRules"
                            :label="$t('accountCreation.accountName')"
                            :hint="$t('accountCreation.oneAccountPerStructure')"
                            v-show="account.type !== 'personnalAccount'"
                            type="text"
                            persistent-hint
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="account.address"
                            :label="$t('accountCreation.accountCity')"
                            type="text"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>

                    <v-btn
                      style="float: right"
                      color="primary"
                      :disabled="
                        !account.type ||
                        (account.type != 'personnalAccount' && !account.name)
                      "
                      @click="nextStep"
                    >
                      {{ $t('accountCreation.continue') }}
                    </v-btn>
                    <!-- <v-btn color="primary" @click="nextStep" :disabled="!validFirstForm">{{ $t('accountCreation.continue') }}</v-btn> -->
                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-form ref="secondForm" v-model="validSecondForm">
                    <v-container grid-list-md text-xs-center>
                      <v-layout row wrap align-center justify-center>
                        <v-flex xs12>
                          <v-textarea
                            v-model="account.purpose"
                            :rules="rules.account.purpose"
                            :label="$t('accountCreation.purpose')"
                            :counter="maxCharPurpose"
                            type="text"
                            required
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-btn flat color="primary" @click="stepper = 1">
                      {{ $t('accountCreation.previous') }}
                    </v-btn>
                    <v-btn
                      style="float: right"
                      color="primary"
                      :disabled="
                        !account.purpose ||
                        (account.purpose.length <= minCharPurpose)
                      "
                      @click="nextStep"
                    >
                      {{ $t('accountCreation.continue') }}
                    </v-btn>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-form ref="thirdForm" v-model="validThirdForm">
                    <v-container grid-list-md text-xs-center>
                      <v-layout column>
                        <v-flex xs12>
                          <v-layout row wrap align-center justify-center>
                            <v-flex xs6>
                              <v-text-field
                                v-model="userInfo.lastname"
                                :rules="rules.user.lastnameRules"
                                :label="$t('accountCreation.lastname')"
                                @blur="checkAccountName"
                                type="text"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="userInfo.firstname"
                                :rules="rules.user.firstnameRules"
                                :label="$t('accountCreation.firstname')"
                                @blur="checkAccountName"
                                type="text"
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12>
                          <v-text-field
                            v-model="userInfo.email"
                            :rules="rules.user.emailRules"
                            :label="$t('accountCreation.email')"
                            type="email"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <VuePhoneNumberInput
                            required
                            v-model="phone"
                            :default-country-code="'FR'"
                            :error="!phoneIsValid"
                            @update="setPhoneNumber"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap align-center justify-center>
                            <v-flex xs5>
                              <v-text-field
                                v-model="userInfo.password"
                                :rules="rules.user.passwordRules"
                                :label="$t('accountCreation.password')"
                                :type="showPasswords ? 'text' : 'password'"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs7 pl-4>
                              <v-text-field
                                v-model="userInfo.confirmPassword"
                                :rules="rules.user.confirmPasswordRules"
                                :label="$t('accountCreation.confirmPassword')"
                                :type="showPasswords ? 'text' : 'password'"
                                :error-messages="confirmPasswordError"
                                :append-outer-icon="
                                  showPasswords
                                    ? 'visibility'
                                    : 'visibility_off'
                                "
                                @click:append-outer="
                                  showPasswords = !showPasswords
                                "
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <!-- <v-flex xs12>
                          <v-text-field
                            v-model="userInfo.promoCode"
                            :label="$t('accountCreation.promoCode')"
                            type="text"
                          ></v-text-field>
                        </v-flex> -->

                        <v-flex xs12 style="max-height: 70px">
                          <v-checkbox
                            v-model="userInfo.confirmCGU"
                            :rules="rules.user.confirmCGURules"
                          >
                            <template v-slot:label>
                              <p class="pt-3">
                                {{ $t('accountCreation.confirm') }}
                                <a
                                  href="https://explorama.app/conditions-generales-dutilisation/"
                                  target="_blank"
                                  >{{ $t('accountCreation.cgu') }}</a
                                >
                              </p>
                            </template>
                          </v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                          <v-alert type="error" :value="errorMessage" outline>
                            {{ translatedError }}
                          </v-alert>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-btn flat color="primary" @click="stepper = 2">
                      {{ $t('accountCreation.previous') }}
                    </v-btn>
                    <v-btn
                      style="float: right"
                      color="primary"
                      @click="createAccount"
                      :disabled="!validThirdForm || !phoneIsValid"
                      >{{ $t('accountCreation.createMyAccount') }}</v-btn
                    >
                  </v-form>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <loading-state :isLoading="isLoading"> </loading-state>
  </v-layout>
</template>

<script>
import LoadingState from '../components/LoadingState';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  name: 'createAccountPage',
  components: {
    LoadingState,
    VuePhoneNumberInput,
  },
  data() {
    return {
      phone: '',
      phoneIsValid: null,
      stepper: 0,
      errorMessage: '',
      showPasswords: false,
      confirmPasswordError: [],
      minCharPurpose: 20,
      maxCharPurpose: 500,
      userInfo: {
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        confirmPassword: '',
        confirmCGU: false,
        promoCode: '',
      },
      account: {
        name: '',
        type: '',
        purpose: '',
        address: '',
      },
      rules: {
        account: {
          nameRules: [
            (name) =>
              Boolean(name) ||
              this.$t('accountCreation.errors.accountNameRequired'),
            (name) =>
              (name &&
                !/(,|"|\*|\\|<|>|\||\/|\?|\#|\+|\)|\(|\$|\%|\&)/.test(name)) ||
              this.$t('accountCreation.errors.containsInvalidCharacter'),
          ],
          typeRules: [
            (type) =>
              Boolean(type) ||
              this.$t('accountCreation.errors.accountTypeRequired'),
          ],
          purpose: [
            (purpose) =>
              Boolean(purpose) ||
              this.$t('accountCreation.errors.purposeRequired'),
            (purpose) =>
              purpose.length >= this.minCharPurpose ||
              this.$t('accountCreation.errors.purposeTooShort'),
          ],
          address: [
            (city) =>
              Boolean(city) ||
              this.$t('accountCreation.errors.addressRequired'),
          ],
        },
        user: {
          firstnameRules: [
            (firstname) =>
              Boolean(firstname) ||
              this.$t('accountCreation.errors.firstnameRequired'),
          ],
          lastnameRules: [
            (lastname) =>
              Boolean(lastname) ||
              this.$t('accountCreation.errors.lastnameRequired'),
          ],

          emailRules: [
            (email) =>
              Boolean(email) || this.$t('accountCreation.errors.emailRequired'),
            (email) =>
              /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/.test(
                email
              ) || this.$t('accountCreation.errors.emailInvalid'),
          ],
          passwordRules: [
            (password) =>
              Boolean(password) ||
              this.$t('accountCreation.errors.passwordRequired'),
            (password) => {
              this.confirmPasswordError = [];
              if (password !== this.userInfo.confirmPassword) {
                this.confirmPasswordError.push(
                  this.$t('accountCreation.errors.mustBeIdentical')
                );
              }
              return true;
            },
          ],
          confirmCGURules: [
            (confirmCGU) =>
              confirmCGU || this.$t('accountCreation.errors.mustConfirmCGU'),
          ],
          confirmPasswordRules: [
            (confirmPassword) =>
              Boolean(confirmPassword) ||
              this.$t('accountCreation.errors.confirmPasswordRequired'),
            (confirmPassword) => {
              this.confirmPasswordError = [];
              if (this.userInfo.password !== confirmPassword) {
                this.confirmPasswordError.push(
                  this.$t('accountCreation.errors.mustBeIdentical')
                );
              }
              return true;
            },
          ],
        },
      },
      validFirstForm: false,
      validSecondForm: false,
      validThirdForm: false,
    };
  },
  computed: {
    translatedError() {
      if (this.errorMessage.match(/.*not connected to.*/)) {
        return this.$t('accountCreation.errors.notConnected');
      }
      if (this.errorMessage.match(/.*Email already used.*/)) {
        return this.$t('accountCreation.errors.alreadyExist');
      }
      return this.$t('accountCreation.errors.generic');
    },
    isLoading() {
      return this.$store.getters['app/isLoading'];
    },
    locale() {
      return this.$i18n.locale;
    },
    accountTypeOptions() {
      return [
        {
          text: this.$t('accountCreation.accountStructure.privateSite'),
          value: 'privateSiteMonument',
        },
        {
          text: this.$t(
            'accountCreation.accountStructure.territoryAndTouristOffice'
          ),
          value: 'territoryAndTouristOffice',
        },
        {
          text: this.$t('accountCreation.accountStructure.agriOeno'),
          value: 'agriOeno',
        },
        {
          text: this.$t('accountCreation.accountStructure.company'),
          value: 'company',
        },
        {
          text: this.$t('accountCreation.accountStructure.education'),
          value: 'education',
        },

        {
          text: this.$t('accountCreation.accountStructure.association'),
          value: 'association',
        },
        {
          text: this.$t('accountCreation.accountStructure.personnalAccount'),
          value: 'personnalAccount',
        },
        {
          text: this.$t('accountCreation.accountStructure.other'),
          value: 'other',
        },
      ];
    },
  },
  methods: {
    nextStep() {
      this.stepper++;
    },
    setPhoneNumber(datas) {
      this.phoneIsValid = datas.isValid;
      if (datas.isValid) {
        this.userInfo.phone = datas.formattedNumber;
      }
    },
    checkAccountName() {
      if (
        this.account.type === 'personnalAccount' &&
        this.userInfo &&
        this.userInfo.lastname &&
        this.userInfo.firstname
      ) {
        this.account.name =
          this.userInfo.firstname.trim() + ' ' + this.userInfo.lastname.trim();
      }
    },
    async createAccount() {
      let hasError = false;
      if (!this.$refs.secondForm.validate()) {
        return;
      }
      await this.$store.commit('app/SET_LOADING');
      let request = {
        controller: 'explorama-plugin/auth',
        action: 'createUser',
        body: {
          email: this.userInfo.email.toLowerCase(),
          password: this.userInfo.password,
          firstname: this.userInfo.firstname,
          lastname: this.userInfo.lastname,
          accountname: this.account.name,
          structureType: this.account.type,
          purpose: this.account.purpose,
          address: this.account.address,
          phone: this.userInfo.phone,
        },
      };
      try {
        await this.$kuzzle.query(request);
      } catch (error) {
        console.error(error.message);
        this.errorMessage = error.message;
        hasError = true;
      }
      if (!hasError) {
        const credentials = {
          username: request.body.email,
          password: request.body.password,
        };
        await this.$store.dispatch('auth/LOGIN', {
          credentials,
          kuzzle: this.$kuzzle,
        });
        this.$router.push('/homePage');
      }
      await this.$store.commit('app/UNSET_LOADING');
    },
  },
};
</script>

<style scoped lang="sass">
.v-stepper
  box-shadow: none
.Title
  padding: 0em
  margin: 0em
  img
    width: 25em
    margin-bottom: 2em
    margin-top: 2em
.primaryCard
  width: 60em
  &-img
    height: 100%
</style>
